export const experiences = [
    {
        title: "AI Developer Intern",
        company: "Revvity",
        dateRange: "Sep - Dec 2026",
        bullets: ["Marketing Product Development Team"],
        techs: ["React.js", "JavaScript"],
    },
    {
        title: "Full-Stack Engineer Intern",
        company: "Xennial Innovations",
        dateRange: "Jan - May 2026",
        bullets: ["Product Development Team"],
        techs: ["React.js", "Express.js", "TypeScript"],
    },
    {
        title: "Software Developer",
        company: "Indosoft Inc.",
        dateRange: "May - August 2025",
        bullets: ["Developed company-specific LLM website using ReactJS and Django"],
        techs: ["React.js", "JavaScript", "Django", "Python"],
    },
    {
        title: "Developer Intern",
        company: "Dynamixware",
        dateRange: "May - August 2023",
        bullets: ["Developed Microsoft Business Central apps in AL"],
        techs: ["Application Language (AL)", "Microsoft BC"],
    },
]
